import { axiosInstance } from "../axios/axiosConfig";

const controller = "ProductTypes";

export const getProductTypes = async () => {
  try {
    const response = await axiosInstance.get(`${controller}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
